import {camelCase, upperFirst} from 'lodash-es';
import {App, Plugin} from 'vue';

export default {
    install(app: App) {

        const componentFiles = import.meta.glob(
            [
                '@/app/**/kl-*.vue',

                // remove kl-viewer as global component
                // @klip/gisvl.klip.viewer@3.1.10+ breaks HOT reload when included (probable because it hosts a new vue app root)
                '!**/kl-viewer/**/*.vue',
            ],
            { eager: true }
        );

        Object.entries(componentFiles).forEach(([path, componentConfig]) => {
            const componentName = upperFirst(
                camelCase(path.split('/').pop().replace(/\.\w+$/, ''))
            );

            app.component(
                `${componentName}`, (componentConfig as any).default
            );
        });

        ///////////////////////////////////////////////////////////////////////////////////////////////////////
        // MIGRATION HELPER: log components with compatConfig
        // if (import.meta.env.VITE_MIGRATION_HELPER) {
        //     let migrationCounter = 1;
        //     Object.entries(componentFiles).forEach(([path, componentConfig]) => {
        //         const componentName = upperFirst(
        //             camelCase(path.split('/').pop().replace(/\.\w+$/, ''))
        //         );
        //
        //         if (((componentConfig as any).default.__file.indexOf(`/shared/`) > -1) &&
        //             (componentConfig as any).default.compatConfig?.MODE !== 3) {
        //             console.log(migrationCounter++, componentName, componentConfig);
        //         }
        //     });
        // }
        // MIGRATION HELPER: log components with compatConfig
        ///////////////////////////////////////////////////////////////////////////////////////////////////////
    },
} as Plugin;
